import { css as i, styled as o } from "styled-components";
import { Dropdown as r } from "../../modules/Dropdown/index.js";
import { MediaQuery as t } from "../../styles/variables.js";
import { SmallLight as m, CaptionLight as a, CaptionHeavy as p } from "../../styles/typography/index.js";
import { Theme as e } from "../../styles/themes/index.js";
const n = i`
  padding: 8px 24px;
  margin-bottom: 16px;
  justify-content: flex-start;
  border: 0;
  border-radius: 0;
  height: unset;

  @media ${t.SCREEN_MD_UP} {
    padding: 8px 24px;
    margin-bottom: 0;
    ${m}
  }
`, f = o(r.Item)`
  && {
    ${n}
    ${a}
    &:hover {
      background-color: rgb(${e.colors.Papa});
    }
  }
`, x = o(r.Item)`
  && {
    ${n}
    ${p}
  color: rgb(${e.colors.Brand});
  }
`, u = o.div`
  margin-top: 32px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;

  @media ${t.SCREEN_MD_UP} {
    margin-top: 0;
    margin-bottom: 20px;
  }
`;
export {
  u as UserMenuInfoContainer,
  f as UserMenuInfoItemContainer,
  x as UserMenuInfoItemContainerSecondary,
  n as defaultStyle
};
